import Debug from 'debug';
import { InteractionStateMachineData } from '../interaction-state-machine-data'
import { InteractionStateService } from '../../interaction-state-service';

const debug = Debug('interaction-loaded-state')

export class LoadedState<TState> {

  public readonly name = 'loaded-state'

  stateEvents: {
  }

  constructor(
    private stateService: InteractionStateService,
    private data: InteractionStateMachineData) {
  }

  enter() {
    debug('enter', this.data.id, this.data.type)
  }

  exit() {
    debug('exit', this.data.id, this.data.type)
  }

  updateInteractionState(state: TState) {

    debug('update-interaction-state', this.data.id, state)

    this.stateService.updateInteractionState({
      id: this.data.id,
      type: this.data.type,
      state: state
    }, { saveInTracking: true })
  }

  updateInteractionResult(progress: number, status: 'incomplete' | 'completed') {

    debug('update-interaction-result', this.data.id, progress, status)

    this.stateService.updateInteractionResult({
      id: this.data.id,
      type: this.data.type,
      progress,
      status
    }, { saveInTracking: true })
  }

}
